// Aidoido brand mark. Inline SVG so it always renders crisp at any size.
// Circular black disc with a stylised capital "A" in the Aidoido cyan/magenta gradient.
export default function AidoidoMark({ size = 64, className = "" }) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="Aidoido"
    >
      <defs>
        <radialGradient id="aidDisc" cx="50%" cy="42%" r="65%">
          <stop offset="0%" stopColor="#111827" />
          <stop offset="100%" stopColor="#000000" />
        </radialGradient>
        <linearGradient id="aidA" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#22D3EE" />
          <stop offset="55%" stopColor="#A78BFA" />
          <stop offset="100%" stopColor="#F472B6" />
        </linearGradient>
        <linearGradient id="aidBar" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stopColor="#22D3EE" />
          <stop offset="100%" stopColor="#F472B6" />
        </linearGradient>
      </defs>
      {/* disc */}
      <circle cx="50" cy="50" r="49" fill="url(#aidDisc)" />
      <circle cx="50" cy="50" r="48.5" fill="none" stroke="#ffffff" strokeOpacity="0.06" />
      {/* Stylised A: two diagonals + crossbar */}
      <path
        d="M50 24 L28 78 M50 24 L72 78"
        fill="none"
        stroke="url(#aidA)"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36 60 L64 60"
        fill="none"
        stroke="url(#aidBar)"
        strokeWidth="7"
        strokeLinecap="round"
      />
      {/* Micro dot on top of the A, matches the CanniComply tittle language */}
      <circle cx="50" cy="18" r="2.4" fill="#F472B6" />
    </svg>
  );
}
